import React from 'react'
import ContentLoader from 'react-content-loader'

const Loader = ({ pageRange }) => {
    const height = 38 * (pageRange + 1)
    const body = new Array(pageRange + 1).fill(null).map((i, ind) => {
        const yStrip = ind ? (39 * ind + 15) : 15
        return (
            <React.Fragment key={ind}>                
                {
                    ind ?
                    <>
                        <rect x='15' y={yStrip - 1} rx='3' ry='3' width='16' height='16' />
                        <rect x='37' y={yStrip} rx='3' ry='3' width='150' height='15' />
                        <rect x='414' y={yStrip} rx='3' ry='3' width='150' height='15' />
                        <rect x='733' y={yStrip} rx='3' ry='3' width='230' height='15' />
                    </> :
                    <>
                        <rect x='15' y={yStrip - 1} rx='3' ry='3' width='16' height='16' />
                        <rect x='37' y={yStrip} rx='3' ry='3' width='106' height='15' />
                        <rect x='414' y={yStrip} rx='3' ry='3' width='56' height='15' />
                        <rect x='733' y={yStrip} rx='3' ry='3' width='45' height='15' />
                    </>
                }
            </React.Fragment>
        )
    })

    return (
        <ContentLoader
            speed={2}
            width={1243}
            height={height}
            viewBox={`0 0 1243 ${height}`}
            backgroundColor='#f3f3f3'
            foregroundColor='#ecebeb'
        >
            <>
                {body}
            </>        
        </ContentLoader>
    )
}

export default Loader